import { render } from "./LoaderSpinner.vue?vue&type=template&id=f16ed5c6&scoped=true"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=f16ed5c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16ed5c6"]])

export default __exports__